import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
const categories = [
    "Nature",
    "Life",
    "Fashion",
    "Portrait",
    "Travel",
    "Wedding",
    "Street",
    "Art",
    "Wildlife"
];
export default function SlidertTopText() {
    const { t } = useTranslation();
    return (
        <div className="btmAni2500 w-full overflow-hidden py-4">
            <motion.div
                className="flex space-x-10"
                initial={{ x: "0%" }}
                animate={{ x: "-100%" }}
                transition={{
                    repeat: Infinity,
                    repeatType: "loop",
                    duration: 10,
                    ease: "linear",
                }}
            >
                {[...categories, ...categories].map((category, index) => (
                    <span
                        key={index}
                        className="text-[32px] text-transparent font-bold uppercase tracking-widest outline-text"
                    >
                        {t(`${category}`)}
                    </span>
                ))}
            </motion.div>
        </div>
    );
}